// extracted by mini-css-extract-plugin
export default {"news":"index_news_YZ61N clearfix","hyh":"index_hyh_aQTZ-"};